import { NgModule } from '@angular/core'
import { Routes, RouterModule } from '@angular/router'
import { HomeComponent } from './components/home/home.component'
import { AboutUsComponent } from './components/about-us/about-us.component'
import { FaqComponent } from './components/faq/faq.component'
import { CareersComponent } from './components/careers/careers.component'
import { CustomerIntentComponent } from './components/customer-intent/customer-intent.component'
import { ContactComponent } from './components/contact/contact.component'
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component'
import { AodaComponent } from './components/aoda/aoda.component'
import { AccessiblePolicyComponent } from './components/accessible-policy/accessible-policy.component'
import { RequestAccountValidationComponent } from './components/customer-requests/request-account-validation/request-account-validation.component'
import { RequestAddressChangeDetailComponent } from './components/customer-requests/request-address-change/detail/request-address-change-detail.component'
import { RequestBankAccountChangeDetailComponent } from './components/customer-requests/request-bank-account-change/detail/request-bank-account-change-detail.component'
import { RequestEmailChangeDetailComponent } from './components/customer-requests/request-email-change/detail/request-email-change-detail.component'
import { RequestEmailChangeValidationComponent } from './components/customer-requests/request-email-change/validation/request-email-change-validation.component'
import { RequestLeaseTransferDetailComponent } from './components/customer-requests/request-lease-transfer/detail/request-lease-transfer-detail.component'
import { RequestLeaseTransferSummaryComponent } from './components/customer-requests/request-lease-transfer/summary/request-lease-transfer-summary.component'
import { RequestListComponent } from './components/customer-requests/request-list/request-list.component'
import { RequestNameChangeDetailComponent } from './components/customer-requests/request-name-change/detail/request-name-change-detail.component'
import { RequestOtherChangeDetailComponent } from './components/customer-requests/request-other-change/detail/request-other-change-detail.component'
import { RequestPaymentDateChangeDetailComponent } from './components/customer-requests/request-payment-date-change/detail/request-payment-date-change-detail.component'
import { RequestPhoneChangeDetailComponent } from './components/customer-requests/request-phone-change/detail/request-phone-change-detail.component'
import { RequestStatusDetailComponent } from './components/customer-requests/request-status/detail/request-status-detail.component'
import { RequestSummaryComponent } from './components/customer-requests/request-summary/request-summary.component'

import { AuthenticationService } from './services/authentication.service'

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    pathMatch: 'full',
  },
  {
    path: 'about-us',
    component: AboutUsComponent,
    pathMatch: 'full',
  } ,
  {
    path: 'lessees-faq',
    component: FaqComponent,
    pathMatch: 'full',
  } ,
  {
    path: 'join-the-cdlsi-team',
    component: CareersComponent,
    pathMatch: 'full',
  },
  {
    path: 'customer-intent',
    component: CustomerIntentComponent,
    pathMatch: 'full',
  },
  {
    path: 'contact-us',
    component: ContactComponent,
    pathMatch: 'full',
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent,
    pathMatch: 'full',
  } ,
  {
    path: 'aoda-multi-year-accessibility-plan',
    component: AodaComponent,
    pathMatch: 'full',
  },
  {
    path: 'accessible-customer-service-policy',
    component: AccessiblePolicyComponent,
    pathMatch: 'full',
  },
  {
    path: 'validate-account',
    component: RequestAccountValidationComponent,
    pathMatch: 'full',
  },
  {
    path: 'request-list',
    component: RequestListComponent,
    pathMatch: 'full',
  },
  {
    path: 'request-status',
    component: RequestStatusDetailComponent,
    pathMatch: 'full',
  },
  {
    path: 'request-summary',
    component: RequestSummaryComponent,
    pathMatch: 'full',
    canActivate: [AuthenticationService]
  },
  {
    path: 'address-change',
    component: RequestAddressChangeDetailComponent,
    pathMatch: 'full',
    canActivate: [AuthenticationService]
  },
  {
    path: 'bank-account-change',
    component: RequestBankAccountChangeDetailComponent,
    pathMatch: 'full',
    canActivate: [AuthenticationService]
  },
  {
    path: 'email-change',
    component: RequestEmailChangeDetailComponent,
    pathMatch: 'full',
    canActivate: [AuthenticationService]
  },
  {
    path: 'email-validation',
    component: RequestEmailChangeValidationComponent,
    pathMatch: 'full',
    canActivate: [AuthenticationService]
  },
  {
    path: 'lease-transfer',
    component: RequestLeaseTransferDetailComponent,
    pathMatch: 'full',
    canActivate: [AuthenticationService]
  },
  {
    path: 'lease-transfer-summary',
    component: RequestLeaseTransferSummaryComponent,
    pathMatch: 'full',
    canActivate: [AuthenticationService]
  },
  {
    path: 'name-change',
    component: RequestNameChangeDetailComponent,
    pathMatch: 'full',
    canActivate: [AuthenticationService]
  },
  {
    path: 'other-change',
    component: RequestOtherChangeDetailComponent,
    pathMatch: 'full',
    canActivate: [AuthenticationService]
  },
  {
    path: 'payment-date-change',
    component: RequestPaymentDateChangeDetailComponent,
    pathMatch: 'full',
    canActivate: [AuthenticationService]
  },
  {
    path: 'phone-change',
    component: RequestPhoneChangeDetailComponent,
    pathMatch: 'full',
    canActivate: [AuthenticationService]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
